import React from 'react'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  formLabel: {
    fontWeight: 'bold',
  },
  content: {
    marginLeft: theme.spacing(4),
  },
}))

interface FormFieldProps {
  label: string
  children: React.ReactNode
}

const FormField: React.FC<FormFieldProps> = ({ label, children }: FormFieldProps): React.ReactElement => {
  const { classes } = useStyles()

  return (
    <div>
      <div className={classes.formLabel}>{label}</div>
      <div className={classes.content}>{children}</div>
    </div>
  )
}
export default FormField
